import { BRAND_MARKS } from "./marks.generated";
export { BRAND_MARKS };
/** The slugs a design may name in `/_stackje/marks/<slug>.svg`. */
export const BRAND_MARK_SLUGS = BRAND_MARKS.map((mark) => mark.slug);
const MARK_URL = /\/_stackje\/marks\/([^"'()\s<>?#\\]*)/g;
const MARK_SLUG = /^[a-z0-9]{1,40}$/;
export function brandMark(slug) {
    return MARK_SLUG.test(slug) ? BRAND_MARKS.find((mark) => mark.slug === slug) : undefined;
}
/** A mark as a standalone SVG: a glyph in the brand's official colour, a full-colour vector as it is, a raster PNG wrapped as an image. */
export function brandMarkSvg(slug) {
    const mark = brandMark(slug);
    if (!mark)
        return undefined;
    if (mark.kind === "svg")
        return mark.markup;
    if (mark.kind === "raster")
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${mark.width} ${mark.height}" width="${mark.width}" height="${mark.height}"><title>${mark.title}</title><image width="${mark.width}" height="${mark.height}" href="data:image/png;base64,${mark.png}"/></svg>`;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" fill="#${mark.hex}"><title>${mark.title}</title><path d="${mark.path}"/></svg>`;
}
/** The slugs as the designer is told them: wordmarks and full-colour marks say so, as they are not one-colour glyphs. */
export function brandMarkSlugList() {
    return BRAND_MARKS.map((mark) => mark.kind === "glyph" ? mark.slug : mark.kind === "svg" ? `${mark.slug} (wordmark, full colour)` : `${mark.slug} (${mark.width > mark.height * 1.5 ? "wordmark" : "app icon"}, full colour, opaque image)`).join(", ");
}
/** Every `/_stackje/marks/<name>.svg` a page or stylesheet names, as written (without the .svg); the same name once. */
export function referencedMarkNames(text) {
    const names = new Set();
    for (const match of text.matchAll(MARK_URL))
        names.add(match[1].replace(/\.svg$/, ""));
    return [...names];
}
/** The referenced marks the pack does not hold (a mistyped name, or a logo the pack lacks). */
export function unknownMarkNames(text) {
    return referencedMarkNames(text).filter((name) => !brandMark(name));
}
/** Parses `/_stackje/marks/<slug>.svg`; undefined for any other path. */
export function markSlugFromPath(requestPath) {
    const match = /^\/_stackje\/marks\/([^/]+)\.svg$/.exec(requestPath);
    return match?.[1];
}
